import React from "react";
import styles from "./styles.module.scss";
import LazyAssets from "@/app/utils/assets_widget";
import classNames from "classnames";
import Button from "@/app/components/button";

interface Props {
  zoom: number;
  setZoom: (zoom: number) => void;
  className?: string
}

const ZoomWidget: React.FC<Props> = ({zoom, setZoom, className}) => {
  return (
    <div className={classNames(styles.widget, className)}>
      <Button onClick={() => setZoom(zoom < 22 ? zoom + 1 : 22)} circle icon={<LazyAssets.Plus/>} isWhite/>
      <Button onClick={() => setZoom(zoom > 0 ? zoom - 1 : 0)} circle icon={<LazyAssets.Minus/>} isWhite/>
    </div>
  );
};

export default ZoomWidget;